import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

const slidersFullWidth = document.querySelectorAll('[data-swiper-main-banner]');
const slidersFullWidthOptions = {
  loop          : false,
  slidesPerView : 1,
  spaceBetween  : 16,
  navigation    : {
    nextEl : '[data-swiper-main-banner-next]',
    prevEl : '[data-swiper-main-banner-prev]'
  },
  pagination: {
    el        : '[data-swiper-main-banner-pag]',
    clickable : true
  }
};

(function initFullWidthSlider() {
  slidersFullWidth.forEach((slider) => new Swiper(slider, slidersFullWidthOptions));
}());
